var exports = {
  "o": "x804f0401--5fac41--snackbar",
};

module.exports = exports;
